import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MeasureService } from '../measure.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-modal-permission-access-measure',
  templateUrl: './modal-permission-access-measure.component.html',
  styleUrls: ['./modal-permission-access-measure.component.scss']
})
export class ModalPermissionAccessMeasureComponent implements OnInit {

  modalData: any;
  allPermission: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalPermissionAccessMeasureComponent>,
    private measureService: MeasureService,
  ) { this.modalData = data; }

  ngOnInit(): void {
    // console.log(this.modalData);
    this.getAllPermission();
  }

  getAllPermission() {
    this.measureService.getListUserPermissionByMeasure(this.modalData.MEASURE_ID).pipe(
      map(res => {
        if (res.success) {
          // console.log(res.result);
          res.result.forEach(e => {
            // console.log(e);
            this.allPermission.push({
              ...e,
              permission: e.MEASURE_CLIEND_ACCEPT_VIEW === 0 ? false : true
            })
          })

          // console.log(this.allPermission);
        }
      })
    ).subscribe();
  }

  accept(value, item) {
    let body = {
      MEASURE_ID: item.MEASURE_ID,
      USER_ID: item.USER_ID,
      MEASURE_CLIEND_ACCEPT_VIEW: value ? 1 : 0,
    }

    // console.log(body);

    this.measureService.updatePermissionViewByMeasure(body).pipe(
      map(res => {
        if (res.success) {
          item.permission = value;
        }
      }),
      catchError(err => {
        alert('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง');
        window.location.reload();
        return of(false);
      })
    ).subscribe();
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

}
